import { Record } from '../transit'

const Location = Record({
  _id: null,
  name: '',
  nameSort: '',
  archived: false,
  archivedAt: null
}, 'location')

export default Location



// WEBPACK FOOTER //
// ./src/common/locations/Location.js